import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { TextField, SingleFilePickerField, SelectField } from '../../components'
import { Alert, Button, Col, Row, SubmitRow } from '../../elements'

import validate from './validate'

class CameraForm extends Component {
    static propTypes = {
        onSubmit: PropTypes.func,
    }
    state = {
        selectedClient: "",
        selectedSite: ""
    }

    changeSiteHandler = (values) => {
        this.setState({ selectedClient: values })
    }

    changeReaderHandler = (values) => {
        this.setState({ selectedSite: values })
    }

    render() {
        const { isSubmiting, handleSubmit, onSubmit, clients, sites, zones, agents, initialValues } = this.props
        const clientIdDisabled = Boolean(get(initialValues, 'clientId'))
        const siteIdDisabled = Boolean(get(initialValues, 'siteId'))
        const cameraSnDisabled = Boolean(get(initialValues, 'cameraSn'))
        const zoneIdDisabled = Boolean(get(initialValues, 'zoneId'))
        const agentIdDisabled = Boolean(get(initialValues, 'agentId'))
        let clientIds = null
        let selectedSiteIds = null
        let siteIds = null
        let selectedZoneIds = null
        let zoneIds = null
        let selectedAgentIds = null
        let agentIds = null
        if(clients){
            clientIds = clients.map(client => client.clientId);
            selectedSiteIds = sites.filter(site => site.clientId == this.state.selectedClient);
            siteIds = selectedSiteIds.map(site => site.siteId)
            selectedZoneIds = zones.filter(zone => zone.clientId == this.state.selectedClient &&
                zone.siteId == this.state.selectedSite);
            zoneIds = selectedZoneIds.map(zone => zone.zoneId)
            selectedAgentIds = agents.filter(agent => agent.clientId == this.state.selectedClient);
            agentIds = selectedAgentIds.map(agent => agent.agentId)
        } else if (initialValues) {
            clientIds = [initialValues.clientId]
            siteIds = [initialValues.siteId]
            zoneIds = [initialValues.zoneId]
            agentIds = [initialValues.agentId]
        }

        if(clientIds == null){
            clientIds = ['']
            siteIds = ['']
            zoneIds = ['']
            agentIds = ['']
        }

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Field
                    name="clientId"
                    label="Client Id"
                    options={clientIds}
                    component={SelectField}
                    onChange={this.changeSiteHandler}
                    className="field"
                    disabled={clientIdDisabled}
                />
                <Field
                    name="cameraSn"
                    label="Camera SN"
                    component={TextField}
                    className="field"
                    disabled={cameraSnDisabled}
                />
                <Field
                    name="siteId"
                    label="Site Id"
                    options={siteIds}
                    component={SelectField}
                    onChange={this.changeReaderHandler}
                    className="field"
                    disabled={siteIdDisabled}
                />
                <Field
                    name="zoneId"
                    label="Zone Id"
                    options={zoneIds}
                    component={SelectField}
                    className="field"
                    disabled={zoneIdDisabled}
                />
                <Field
                    name="agentId"
                    label="Agent Id"
                    options={agentIds}
                    component={SelectField}
                    className="field"
                    disabled={agentIdDisabled}
                />
                <Field
                    name="endpoint"
                    label="Endpoint"
                    disabled={isSubmiting}
                    component={TextField}
                    className="field"
                />
                <SubmitRow>
                    <Row type="flex" gutter={20}>
                        <Col>
                            <Button htmlType="submit" type="primary" wide>
                                {siteIdDisabled ? 'Save' : 'Create'}
                            </Button>
                        </Col>
                    </Row>
                </SubmitRow>
            </form>
        )
    }
}

export default reduxForm({
    form: 'camera-form',
    validate,
})(CameraForm)



// WEBPACK FOOTER //
// ./src/smart-components/camera-form/index.js